import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const [brands, setBrands] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(
    () => localStorage.getItem("dasarro_brand") || "All Brands"
  );
  const [selectedHub, setSelectedHub] = useState(
    () => localStorage.getItem("dasarro_hub") || "All Hubs"
  );

  const refreshBrands = () => api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  const refreshHubs = () => api.get("/hubs").then((r) => setHubs(r.data)).catch(() => {});
  useEffect(() => { refreshBrands(); refreshHubs(); }, []);

  const choose = (b) => { setSelectedBrand(b); localStorage.setItem("dasarro_brand", b); };
  const chooseHub = (h) => { setSelectedHub(h); localStorage.setItem("dasarro_hub", h); };

  return (
    <BrandContext.Provider value={{
      brands, hubs, selectedBrand, selectedHub,
      setSelectedBrand: choose, setSelectedHub: chooseHub, refreshBrands, refreshHubs,
    }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext);
